@if (isRunAsLibrary) {
  <st-loader></st-loader>
}
@if (currentRole == userRoles.Admin) {
  <app-emergency-alert></app-emergency-alert>
}
<main
  class="main rides-board-view background-fill-beacon-bg"
  #mainContainer
  [ngClass]="{ 'fixed-board': isRunAsLibrary }"
  [style]="'min-height: ' + calculated100dvh()">
  <div class="exit-btn-container">
    <button
      class="exit-btn px-spacing-3xl py-spacing-sm radius-lg background-surface-base-alpha-30-bg border-none text-inverse-color title-large-medium"
      style="backdrop-filter: blur(12.5px)"
      (click)="navigateToMC()">
      Exit
    </button>
  </div>
  @if (ridesData.length > 0) {
    <div class="table-container h-full py-spacing-md px-spacing-3xl flex justify-content-center align-items-start">
      <p-table
        #primeTable
        [value]="ridesData"
        [rowTrackBy]="trackByRideId"
        [scrollable]="true"
        [scrollHeight]="viewportHeight()"
        [lazy]="true"
        [totalRecords]="totalRecords"
        class="w-full"
        [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template #header>
          <tr class="background-fill-beacon-bg">
            @for (col of columns; track $index) {
              <th
                [id]="'tableCol_' + $index"
                class="background-fill-beacon-bg vertical-align-baseline px-spacing-3xl py-spacing-xl title-large-bold text-white-alpha-90 uppercase resizable-column">
                <div class="column-header-content">
                  <span>{{ col | keyDisplayName }}</span>
                  <span
                    class="column-resizer"
                    (mousedown)="onResizeStart($event, $index)"></span>
                </div>
              </th>
            }
          </tr>
        </ng-template>
        <ng-template
          #body
          let-ride
          let-rowIndex="rowIndex">
          <tr
            [style]="'--i: ' + rowIndex"
            [attr.data-item-id]="ride.id"
            [attr.data-previous-index]="ride.previousIndex"
            [attr.data-current-index]="ride.currentIndex"
            [style.transform]="ride.transform ?? 'translateY(0)'"
            [ngClass]="{
              'dark-row': 0 != rowIndex % 2,
              'lighter-row': 0 == rowIndex % 2,
              animate: ride['alert'],
              'position-changing': ride.previousIndex !== ride.currentIndex,
              'no-transition': ride.skipTransition
            }">
            @for (col of columns; track $index) {
              <td [class]="col + '-class px-spacing-3xl py-spacing-sm headline-small-bold text-white'">
                @if (col != "arrivalTime" && col != "departureTime" && col != "status" && col != "rideAlert" && col != "studentNames") {
                  <span
                    class="data-item"
                    [pTooltip]="ride[col] != 'N/A' ? ride[col] : ''"
                    [tooltipOptions]="tooltipOptions">
                    <span>{{ ride[col] }}</span>
                  </span>
                }

                @if (col == "arrivalTime" || col == "departureTime") {
                  <div class="flex align-items-center gap-spacing-md">
                    <span class="time">
                      {{ ride[col].time }}
                    </span>
                    @if (ride[col].timeAdjustment) {
                      <span
                        class="time-diff radius-full py-spacing-3xs px-spacing-xs title-large-bold text-inverse-color"
                        [ngClass]="{
                          'background-fill-warning-bg': +ride[col].timeAdjustment > 1 && +ride[col].timeAdjustment <= 5,
                          'background-fill-danger-bg': +ride[col].timeAdjustment > 5,
                          'button-success-default-bg': +ride[col].timeAdjustment < -1,
                          'text-inverse-bg background-fill-beacon-color': +ride[col].timeAdjustment >= -1 && +ride[col].timeAdjustment <= 1
                        }">
                        <span class="time-diff-value">
                          {{ ride[col].timeAdjustment }}
                        </span>
                      </span>
                    }
                  </div>
                }

                @if (col == "studentNames") {
                  <div class="flex flex-column gap-spacing-2xs">
                    <span
                      class="data-item cursor-pointer underline"
                      (click)="openStudentsListDialog(ride.studentNames)"
                      (keydown.enter)="openStudentsListDialog(ride.studentNames)">
                      {{ ride.studentNames?.length }}
                    </span>
                  </div>
                }

                @if (col == "rideAlert") {
                  <div class="flex align-items-center gap-spacing-xl">
                    <span
                      class="ride-alert-status-indicator"
                      [ngClass]="{
                        'background-fill-danger-bg background-fill-danger-border': ride[col].color == severityLevel().DANGER,
                        'icon-success-subtle-bg icon-success-subtle-border': ride[col].color == severityLevel().SUCCESS,
                        'icon-warning-subtle-bg icon-warning-subtle-border': ride[col].color == severityLevel().WARNING,
                        'bg-white border-white': ride[col].title.toLowerCase() == 'on time' || ride[col].color == severityLevel().INFO,
                        'bg-transparent icon-lightest-border': ride[col].title.toLowerCase() == 'canceled',
                        animate:
                          ride[col].title.toLowerCase() == 'delayed' || ride[col].title.toLowerCase() == 'declined' || ride[col].title.toLowerCase() == 'attention' || ride[col].title.toLowerCase() == 'late' || ride[col].title.toLowerCase() == 'early'
                      }">
                    </span>
                    <span>
                      {{ ride[col].title }}
                    </span>
                  </div>
                }

                @if (col == "status") {
                  <span
                    class="ride-tag py-spacing-2xs px-spacing-xl radius-md title-large-bold text-inverse-color"
                    [pTooltip]="ride[col]"
                    [tooltipOptions]="tooltipOptions"
                    [ngClass]="{
                      'background-fill-danger-bg': ride['statusSeverity'] == severityLevel().DANGER,
                      'background-fill-success-bg': ride['statusSeverity'] == severityLevel().SUCCESS,
                      'feedback-info-fg-bg': ride['statusSeverity'] == severityLevel().INFO,
                      'feedback-gray-fg-bg': ride['statusSeverity'] == severityLevel().SECONDARY,
                      animate: ride.statusUpdated
                    }">
                    {{ ride[col] }}</span
                  >
                }
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</main>
